/**
 * Permission names, mirroring the API's `Permissions` constants (M0-22).
 *
 * Only the *names* live here. Which permissions the signed-in user actually
 * holds is whatever `/api/v1/me` returns — the role → permission matrix is
 * never reimplemented in the browser, so the two cannot drift.
 *
 * And none of this is a security boundary. Everything here decides what to
 * *show*; the API decides what may *happen*. A user who edits their way past a
 * guard reaches an endpoint that refuses them.
 */
export const Permissions = {
  manageAccount: 'account.manage',
  manageBilling: 'billing.manage',
  readUsers: 'users.read',
  manageUsers: 'users.manage',
  readCustomers: 'customers.read',
  manageCustomers: 'customers.manage',
  readAllJobs: 'jobs.read.all',
  assignJobs: 'jobs.assign',
  workAssignedJobs: 'jobs.work',
  managePricebook: 'pricebook.manage',
  /** Draft estimates and search the price book to build them (M2-06). Every role; the API narrows a technician to their own jobs. */
  buildEstimates: 'estimates.build',
  /** The company's profile, logo, hours and timezone (M2-19). Owner and Admin. */
  manageCompany: 'company.manage',
} as const;

export type Permission = (typeof Permissions)[keyof typeof Permissions];
